import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface SecureQuoteStore {
  quoteIds: string[];

  addQuoteId: (quoteId: string) => void;
  removeQuoteId: (quoteId: string) => void;
  clearQuoteIds: () => void;

  saveDetails: boolean;
  setSaveDetails: (saveDetails: boolean) => void;
}

export const useSecureQuoteStore = create<SecureQuoteStore>()(
  persist(
    (set) => ({
      quoteIds: [],
      addQuoteId: (quoteId: string) =>
        set((state) => ({ quoteIds: [...state.quoteIds, quoteId] })),
      removeQuoteId: (quoteId: string) =>
        set((state) => ({
          quoteIds: state.quoteIds.filter((id) => id !== quoteId),
        })),
      clearQuoteIds: () => set({ quoteIds: [] }),

      saveDetails: false,
      setSaveDetails: (saveDetails: boolean) => set({ saveDetails }),
    }),
    {
      name: "secure-quote",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
